// extracted by mini-css-extract-plugin
export var grid = "_2i-0";
export var span1 = "_2i-2";
export var span10 = "_2i-b";
export var span10L = "_2i-z";
export var span10M = "_2i-n";
export var span10Xl = "_2i-1b";
export var span11 = "_2i-c";
export var span11L = "_2i-10";
export var span11M = "_2i-o";
export var span11Xl = "_2i-1c";
export var span12 = "_2i-d";
export var span12L = "_2i-11";
export var span12M = "_2i-p";
export var span12Xl = "_2i-1d";
export var span1L = "_2i-q";
export var span1M = "_2i-e";
export var span1Xl = "_2i-12";
export var span2 = "_2i-3";
export var span2L = "_2i-r";
export var span2M = "_2i-f";
export var span2Xl = "_2i-13";
export var span3 = "_2i-4";
export var span3L = "_2i-s";
export var span3M = "_2i-g";
export var span3Xl = "_2i-14";
export var span4 = "_2i-5";
export var span4L = "_2i-t";
export var span4M = "_2i-h";
export var span4Xl = "_2i-15";
export var span5 = "_2i-6";
export var span5L = "_2i-u";
export var span5M = "_2i-i";
export var span5Xl = "_2i-16";
export var span6 = "_2i-7";
export var span6L = "_2i-v";
export var span6M = "_2i-j";
export var span6Xl = "_2i-17";
export var span7 = "_2i-8";
export var span7L = "_2i-w";
export var span7M = "_2i-k";
export var span7Xl = "_2i-18";
export var span8 = "_2i-9";
export var span8L = "_2i-x";
export var span8M = "_2i-l";
export var span8Xl = "_2i-19";
export var span9 = "_2i-a";
export var span9L = "_2i-y";
export var span9M = "_2i-m";
export var span9Xl = "_2i-1a";
export var stretch = "_2i-1";